<form [formGroup]="e" (ngSubmit)="leaseDetailService.saveNegotiation()">
  <div class="grid">
    <div class="col-12">
      <div class="main-title">
        Garantía
      </div>
    </div>
    <div class="col-12 md:col-6 xl:col-4">
      <div class="field field-flex">
        <label for="guaranty">Garantía:*</label>
        <div class="flex justify-content-center flex-column">
          <p-dropdown formControlName="guaranty" [panelStyle]="{'width': '100%' }" [style]="{'height': '45px'}" scrollHeight="150px" [options]="leaseDetailService.guaranties" optionLabel="label" optionValue="value" [filter]="true" filterBy="label" [showClear]="true" placeholder="Selecciona un tipo de arrendamiento">
            <ng-template pTemplate="selectedItem">
              <div class="flex align-items-center" *ngIf="e.value.guaranty">
                <div>{{leaseDetailService.getGuarantyName(e.value.guaranty)}}</div>
              </div>
            </ng-template>
            <ng-template let-guaranty pTemplate="item">
              <div class="flex align-items-center">
                <div>{{ guaranty.label }}</div>
              </div>
            </ng-template>
          </p-dropdown>
          <ng-container *ngIf="e.get('guaranty')?.invalid && (e.get('guaranty')?.dirty || e.get('guaranty')?.touched)">
            <small class="p-error" *ngIf="e.get('guaranty')?.errors?.['required']">La garantía es obligatoria.</small>
          </ng-container>
        </div>
      </div>
    </div>
    <div class="col-12 md:col-6 xl:col-4">
      <div class="field field-flex">
        <label for="totalValue">Valor total:*</label>
        <p-inputNumber formControlName="totalValue" inputId="totalValue" mode="currency" currency="MXN" locale="es-MX"> </p-inputNumber>
        <ng-container *ngIf="e.get('totalValue')?.invalid && (e.get('totalValue')?.dirty || e.get('totalValue')?.touched)">
          <small class="p-error" *ngIf="e.get('totalValue')?.errors?.['required']">El valor total es obligatorio.</small>
          <small class="p-error" *ngIf="e.get('totalValue')?.errors?.['min']">El valor mínimo es {{e.get('totalValue')?.errors?.['min']['min']}}.</small>
        </ng-container>
      </div>
    </div>
    <div class="col-12 md:col-6 xl:col-4">
      <app-input-single-file
        label="Documentación"
        (fileUrl)="onFileSelected($event)"
        (fileDeleted)="onFileDeleted()"
        (downloadRequested)="onDownloadRequested($event)"
        [tooltip]="'Documento de negociación del arrendamiento'"
        [documentName]="'negotiationDocument'"
        [folder]="'negotiation'"
        [id]="leaseDetailService.id"
        [fileUrlValue]="leaseDetailService.data?.negotiation?.document"
      ></app-input-single-file>
    </div>
    <div class="col-12 text-right">
      <button pButton pRipple label="Guardar" icon="fa-solid fa-check" class="p-button-success" type="submit"></button>
    </div>
  </div>
</form>